<ng-container *ngIf="working">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="working === false">
  <div class="dialog-header">
    <h2>Detalles de la cita</h2>
    <button mat-stroked-button mat-dialog-close class="close-btn">×</button>
  </div>

  <mat-dialog-content>
    <p><strong>Título:</strong> {{ data.newEvent.title }}</p>
    <p><strong>Contacto:</strong> {{ contact.companyName || 'N/D' }}</p>
    <p><strong>Concepto:</strong> {{ concept.name || 'N/D' }}</p>
    <p><strong>Descripción:</strong> {{ data.newEvent.description || 'Sin descripción'}}</p>
    <p><strong>Observaciones:</strong> {{ data.newEvent.observations || 'Sin notas' }}</p>
    <p><strong>Inicio:</strong> {{ data.newEvent.startDate | date:'short' }}</p>
    <p><strong>Fin:</strong> {{ data.newEvent.endDate | date:'short' }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" class="ticket-btn me-2" (click)="createPreinvoice()">Crear
      presupuesto</button>
    <button mat-flat-button class="btn-convfact" style="margin-right: 10px;" (click)="edit()">Editar</button>
    <button mat-flat-button class="btn-danger" (click)="delete()">Borrar</button>
  </mat-dialog-actions>
</ng-container>